
import { defineComponent, onMounted } from 'vue'

import { useStore } from '@/store/index'
import { toArray } from '@/utils/array'

export default defineComponent({
  setup() {
    const store = useStore()

    onMounted(() => {
      if (! store.state.base.alert.persistent) {
        store.commit('base/setAlertMessages', { messages: undefined })
      } else {
        store.commit('base/setAlertMessages', { messages: store.state.base.alert.messages, persistent: false })
      }
    })

    return {
      store,
      toArray
    }
  },
})
